import { WidgetClientEvent, WidgetMessengerEvent } from "../../types";
import store from "../store";

class MessageHelper {
  static sendMessengerFrameMessage(message: WidgetClientEvent) {
    const { application: { messengerFrame } } = store.getState()

    messengerFrame?.contentWindow?.postMessage(message, '*');
  }

  static sendMessage(message: WidgetMessengerEvent) {
    window.parent.postMessage(message, '*')
  }
}

export default MessageHelper